module.exports = __webpack_public_path__ + "static/img/imprint.9722a01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WechatPay/imprint.png
// module id = 4a78
// module chunks = 4